module.exports = __webpack_public_path__ + "img/close.bf89e8a2.svg";